import { useTranslation } from 'react-i18next';

import { NO_DATA } from 'constants/common';
import { DAY_FORMAT_WITH_TIME } from 'constants/global';
import { RepaymentDetails } from 'interfaces/integrations/gocardless.interface';
import { LabelWithValue } from 'shared-components';
import { getFormattedDate } from 'utils/dates';
import { useFormatPriceFunction } from 'utils/global';

import { sharedBodyClass, sharedLabelClass, sharedValueClass } from '../const';

interface Props {
  isError?: boolean;
  data?: RepaymentDetails;
  isLoading: boolean;
}

const RepaymentInformation = ({ data, isLoading }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      <LabelWithValue
        bodyClassName={sharedBodyClass}
        labelClassName={sharedLabelClass}
        valueClassName={sharedValueClass}
        withColon={true}
        label={t('RepaymentRef')}
        value={t(data?.referenceId || NO_DATA)}
        isLoading={isLoading}
      />
      <LabelWithValue
        bodyClassName={sharedBodyClass}
        labelClassName={sharedLabelClass}
        valueClassName={sharedValueClass}
        withColon={true}
        label={t('TotalAmount')}
        value={useFormatPriceFunction(data?.totalAmount || 0)}
        isLoading={isLoading}
      />
      <LabelWithValue
        bodyClassName={sharedBodyClass}
        labelClassName={sharedLabelClass}
        valueClassName={sharedValueClass}
        withColon={true}
        label={t('PaymentType')}
        value={t(data?.paymentType || NO_DATA)}
        isLoading={isLoading}
      />
      <LabelWithValue
        bodyClassName={sharedBodyClass}
        labelClassName={sharedLabelClass}
        valueClassName={sharedValueClass}
        withColon={true}
        label={t('Status')}
        value={t(data?.status || NO_DATA)}
        isLoading={isLoading}
      />
      <LabelWithValue
        bodyClassName={sharedBodyClass}
        labelClassName={sharedLabelClass}
        valueClassName={sharedValueClass}
        withColon={true}
        label={t('CreationTime')}
        value={getFormattedDate(data?.createdDate, DAY_FORMAT_WITH_TIME)}
        isLoading={isLoading}
      />
    </div>
  );
};

export default RepaymentInformation;
